import { Link } from "react-router-dom";
import { Icon } from "@/components/layout/Icon";

/** A proper 403 page for a gated route the signed-in user cannot reach, so a
 * deep link to an unauthorised page reads as "access denied" rather than a
 * silent bounce to the dashboard. */
export function AccessDenied() {
  return (
    <div className="flex h-[70vh] flex-col items-center justify-center text-center">
      <div className="flex h-16 w-16 items-center justify-center rounded-full bg-red-100 text-red-600">
        <Icon name="lock" className="h-7 w-7" />
      </div>
      <h1 className="mt-4 text-xl font-semibold text-slate-900">Access Denied</h1>
      <p className="mt-1 max-w-sm text-sm text-slate-500">
        Your role does not have permission to view this page. If you believe this is a mistake, contact your
        administrator.
      </p>
      <Link
        to="/"
        className="mt-6 rounded-lg bg-primary-600 px-4 py-2 text-sm font-medium text-white hover:bg-primary-700"
      >
        Back to dashboard
      </Link>
    </div>
  );
}
